var render, staticRenderFns
import script from "./body-row-column.vue?vue&type=script&lang=js&"
export * from "./body-row-column.vue?vue&type=script&lang=js&"
import style0 from "./body-row-column.vue?vue&type=style&index=0&id=402b2d3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b2d3c",
  null
  
)

export default component.exports